import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AuthService } from '../core/services/auth.service';
import { I18nService } from '../core/services/i18n.service';
import { TokenService } from '../core/services/token.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  template: `
    <header class="header">
      <div class="language-box">
        <span>{{ i18n.t('common.language') }}</span>
        <button type="button" [class.active]="i18n.currentLanguage() === 'en'" (click)="setLanguage('en')">
          {{ i18n.t('common.english') }}
        </button>
        <button type="button" [class.active]="i18n.currentLanguage() === 'ar'" (click)="setLanguage('ar')">
          {{ i18n.t('common.arabic') }}
        </button>
      </div>
      <div class="user-box">
        <span>{{ fullName }}</span>
        <button type="button" class="logout-btn" (click)="logout()">{{ i18n.t('actions.logout') }}</button>
      </div>
    </header>
  `,
  styles: [`
    .header { display:flex; justify-content:space-between; align-items:center; padding:16px 24px; border-bottom:1px solid #e5e7eb; background:#fff; gap:16px; flex-wrap:wrap; }
    .language-box, .user-box { display:flex; gap:12px; align-items:center; }
    button { border:1px solid #cbd5e1; background:#fff; color:#0f172a; padding:8px 14px; border-radius:8px; cursor:pointer; }
    button.active, .logout-btn { background:#111827; color:#fff; border-color:#111827; }
  `]
})
export class HeaderComponent {
  private readonly authService = inject(AuthService);
  private readonly tokenService = inject(TokenService);
  readonly i18n = inject(I18nService);

  get fullName(): string {
    return this.tokenService.getCurrentUser()?.fullName ?? this.i18n.t('common.user');
  }

  setLanguage(language: 'en' | 'ar'): void {
    this.i18n.setLanguage(language);
  }

  logout(): void {
    this.authService.logout();
  }
}
